import { render, staticRenderFns } from "./EditOrganizationDialog.vue?vue&type=template&id=77a26923&scoped=true&"
import script from "./EditOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./EditOrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganizationDialog.vue?vue&type=style&index=0&id=77a26923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a26923",
  null
  
)

export default component.exports